import cutileiApi from '../../../../services/cutileiApi'
import AuthService from '../../../../services/auth'
import ratingValidator from '../../../../validators/ratingValidator'
import CustomerSchedule from 'components/CustomerSchedule'
import MainButton from 'components/Buttons/MainButton'
import submitOnEnter from 'utils/submitOnEnter'
import { FaStar } from 'react-icons/fa'
import { Formik } from 'formik'
import Rating from 'react-rating'

import {
  Form,
  FormField,
  Row,
  Title,
  TextArea,
  InfoText,
  WarningText
} from '../styles'

export default function RateProfessional ({
  schedule,
  onConfirm: handleConfirm
}) {
  const token = AuthService.getToken ()

  const requestConfig = {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  }

  return (
    <Formik
      validationSchema={ratingValidator}
      initialValues={{
        'value': 0,
        'comment': ''
      }}
      onSubmit={async values => {
        const { data: professionalRating } = await cutileiApi.post (
          `/professionals/${schedule.professional?.id}/ratings`, {
            ...values,
            customerId: schedule.customer?.id,
            businessId: schedule.business.id,
            scheduleId: schedule.id
          }, requestConfig
        )

        handleConfirm (professionalRating)
      }}
    >
      {({
        values,
        errors,
        touched,
        isSubmitting,
        handleChange,
        handleBlur,
        setFieldValue,
        handleSubmit
      }) => {
        return (
          <Form onSubmit={handleSubmit} onKeyDown={submitOnEnter(handleSubmit, isSubmitting)}>
            <CustomerSchedule
              data={schedule}
              showActions={false}
              containerStyle={{width: 400, marginBottom: 20}}
            />
            <Title>Avaliar profissional</Title>
            <InfoText>
              Como você avalia o profissional neste agendamento?
            </InfoText>
            <FormField style={{marginBottom: 20}}>
              <Row>
                <Rating
                  initialRating={values.value}
                  onChange={value => setFieldValue ('value', value)}
                  emptySymbol={<FaStar color='#BEBEBE' size={30}/>}
                  fullSymbol={<FaStar color='#FFC100' size={30}/>}
                />
                <Title style={{fontSize: 20, margin: 0}}>
                  {values.value > 0 ? values.value : ''}
                </Title>
              </Row>
              {errors.value && touched.value && (
                <WarningText>
                  {errors.value}
                </WarningText>
              )}
            </FormField>
            <FormField>
              <TextArea
                placeholder='Escreva um comentário sobre o profissional (opcional para avaliações de 4 e 5 estrelas)'
                rows={3}
                value={values.comment}
                onChange={handleChange ('comment')} 
                onBlur={handleBlur ('comment')}
              />
              {touched.comment && errors.comment && (
                <WarningText>
                  {errors.comment}
                </WarningText>
              )}
            </FormField>
            <MainButton
              label='Enviar avaliação'
              width={140}
              onClick={handleSubmit}
              disabled={isSubmitting}
              loading={isSubmitting}
            />
          </Form>
        )
      }}
    </Formik>
  )
}
